import React from "react";
import { Link } from "react-router-dom";

const Support = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-[#020617] via-[#111827] to-[#1e293b] text-white font-calistoga relative overflow-hidden">
      {/* soft glow */}
      <div
        className="pointer-events-none absolute inset-0 opacity-45 mix-blend-soft-light
               bg-[radial-gradient(circle_at_top,_#facc1540,_transparent_60%)]"
        aria-hidden="true"
      />

      {/* Header (same as Home) */}
      <header className="">
        <div className="max-w-[1000px] mx-auto px-6 pt-8 flex items-center justify-between">
          <Link to="/">
            <span className="text-2xl font-medium tracking-wide">
              Ebbinghaus
            </span>
          </Link>
        </div>
      </header>

      {/* Main content */}
      <main className="relative z-10 px-6 py-16 mx-auto w-full max-w-[1000px] ">
        <div className="">
          <div className="rounded-3xl">
            <h1 className="text-3xl sm:text-4xl mb-8">
              Support
            </h1>

            <p className="font-nunito text-sm sm:text-base text-white/85">
              If you need support, have found a bug, or have any questions
              related to Ebbinghaus, feel free to contact me by email:
            </p>

            <p className="font-nunito text-sm sm:text-base text-white mt-5 break-words">
              <a
                href="mailto:learnrussiancases@gmail.com"
                className="underline decoration-white/60 underline-offset-2 hover:decoration-white"
              >
                learnrussiancases@gmail.com
              </a>
            </p>
          </div>
        </div>
      </main>

      {/* Footer (same as Home) */}
      <footer className="relative z-10 bg-black/60 text-white text-center text-sm py-4 mt-auto">
        <a
          href="https://josephmalam.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="px-2 font-nunito text-sm font-semibold "
        >
          &copy;{" "}
          <span className="underline decoration-white/50">Joseph Malam</span>{" "}
          2022-2025
        </a>
        <div className="flex flex-row items-center justify-center pt-2 font-nunito text-xs">
          <Link to="/support" className="px-2 underline decoration-white/50">
            Support
          </Link>
          &bull;
          <Link to="/privacy" className="px-2 underline decoration-white/50">
            Privacy Policy
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default Support;
